import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import HeaderDashboard from "../../Components/HeaderDashboard";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { AuthContext } from "../../Routes/AuthProvider";
import { getAllHotelBookings } from "../../Services/HotelSearchApi";

const AllTransactions = () => {
  const { userName } = useContext(AuthContext);
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    bookingRefNo: "",
    bookingStatus: "",
    paymentStatus: "",
    hotelName: "",
    hotelPNR: "",
  });

  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasSearched, setHasSearched] = useState(false);
  const recordsPerPage = 20;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const convertToDate = (str) => {
    if (!str) return null;
    const [day, month, year] = str.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const formatDateForApi = (dateStr, isEnd = false) => {
    if (!dateStr) return undefined;
    const dateObj = convertToDate(dateStr);
    if (!dateObj || isNaN(dateObj.getTime())) return undefined;

    const pad = (num) => String(num).padStart(2, '0');
    const year = dateObj.getFullYear();
    const month = pad(dateObj.getMonth() + 1);
    const day = pad(dateObj.getDate());
    const hours = isEnd ? "23" : "00";
    const minutes = isEnd ? "59" : "00";
    const seconds = isEnd ? "59" : "00";
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    $("#fromDate").datepicker({
      dateFormat: "dd/mm/yy",
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          fromDate: dateText,
        }));
      },
    });

    $("#toDate").datepicker({
      dateFormat: "dd/mm/yy",
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          toDate: dateText,
        }));
      },
    });
  }, []);

  // UPDATE minDate of ToDate WHEN fromDate changes
  useEffect(() => {
    if (filters.fromDate) {
      const minD = convertToDate(filters.fromDate);
      $("#toDate").datepicker("option", "minDate", minD);
    }
  }, [filters.fromDate]);

  const handleSearch = async () => {
    setLoading(true);
    setHasSearched(true);
    try {
      const fromDateParam = formatDateForApi(filters.fromDate, false);
      const toDateParam = formatDateForApi(filters.toDate, true);
      const data = await getAllHotelBookings(
        userName,
        filters.bookingStatus,
        filters.paymentStatus,
        fromDateParam,
        toDateParam,
        filters.hotelPNR,
        filters.bookingRefNo,
        filters.hotelName
      );

      let list = [];
      if (Array.isArray(data)) {
        list = data;
      } else if (data?.bookings && Array.isArray(data.bookings)) {
        list = data.bookings;
      } else if (
        data?.data?.allHotelBookings &&
        Array.isArray(data.data.allHotelBookings)
      ) {
        list = data.data.allHotelBookings;
      } else if (data?.data && Array.isArray(data.data)) {
        list = data.data;
      } else if (data?.allTransactions && Array.isArray(data.allTransactions)) {
        list = data.allTransactions;
      } else if (
        data?.allHotelBookings &&
        Array.isArray(data.allHotelBookings)
      ) {
        list = data.allHotelBookings;
      } else if (
        data?.data?.allTransactions &&
        Array.isArray(data.data.allTransactions)
      ) {
        list = data.data.allTransactions;
      }

      console.log("Extracted List:", list);

      if (filters.bookingRefNo) {
        list = list.filter((item) => {
          const ref = (
            item.bookingRefId ||
            item.BookingRefId ||
            item.confirmationNo ||
            item.ConfirmationNo ||
            item.referenceNo ||
            item.ReferenceNo ||
            ""
          ).toLowerCase();
          return ref.includes(filters.bookingRefNo.toLowerCase());
        });
      }
      if (filters.hotelPNR) {
        list = list.filter((item) => {
          const pnr = (
            item.hotelPNR ||
            item.HotelPNR ||
            item.confirmationNo ||
            item.ConfirmationNo ||
            item.pnr ||
            item.PNR ||
            ""
          ).toLowerCase();
          return pnr.includes(filters.hotelPNR.toLowerCase());
        });
      }
      if (filters.hotelName) {
        list = list.filter((item) => {
          const hotel = (item.hotelName || item.HotelName || "").toLowerCase();
          const city = (item.cityName || item.CityName || "").toLowerCase();
          const search = filters.hotelName.toLowerCase();
          return hotel.includes(search) || city.includes(search);
        });
      }
      if (filters.bookingStatus) {
        list = list.filter((item) => {
          const status = (item.bookingStatus || item.BookingStatus || "").toUpperCase();
          return status === filters.bookingStatus.toUpperCase();
        });
      }
      if (filters.paymentStatus) {
        list = list.filter((item) => {
          const status = (item.paymentStatus || item.PaymentStatus || "").toUpperCase();
          return status === filters.paymentStatus.toUpperCase();
        });
      }
      if (filters.fromDate || filters.toDate) {
        const fromLimit = filters.fromDate ? convertToDate(filters.fromDate) : null;
        if (fromLimit) fromLimit.setHours(0, 0, 0, 0);

        const toLimit = filters.toDate ? convertToDate(filters.toDate) : null;
        if (toLimit) toLimit.setHours(23, 59, 59, 999);

        list = list.filter((item) => {
          const itemDateStr = item.createdAt || item.CreatedAt || item.bookingDate || item.BookingDate;
          if (!itemDateStr) return false;
          const itemDate = new Date(itemDateStr);
          if (isNaN(itemDate.getTime())) return false;

          if (fromLimit && itemDate < fromLimit) return false;
          if (toLimit && itemDate > toLimit) return false;
          return true;
        });
      }

      setTransactions(list);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error fetching hotel transactions:", error);
      alert("Failed to fetch transactions. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (userName) {
      handleSearch();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userName]);

  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch (e) {
      return dateStr;
    }
  };

  // Calculate pagination values
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = transactions.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(transactions.length / recordsPerPage);

  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);

      let start = Math.max(2, currentPage - 1);
      let end = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 2) {
        end = 4;
      } else if (currentPage >= totalPages - 1) {
        start = totalPages - 3;
      }

      if (start > 2) {
        pageNumbers.push("...");
      }

      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }

      if (end < totalPages - 1) {
        pageNumbers.push("...");
      }

      pageNumbers.push(totalPages);
    }
    return pageNumbers;
  };

  return (
    <>
      <style>{`
        .ui-datepicker {
          z-index: 9999 !important;
        }
      `}</style>
      <HeaderDashboard />

      <div className="toolbar py-2" id="kt_toolbar">
        <div className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1">
            <div className="page-title d-flex align-items-center flex-wrap">
              <h1 className="text-gray-900 fw-bold fs-3">Reservations</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li className="breadcrumb-item text-muted">Hotel</li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-gray-900">
                  All Transactions
                </li>
              </ul>
            </div>
          </div>
          <div className="d-flex align-items-center flex-wrap">
            <div className="flex-shrink-0 me-2 d-none-mob">
              <ul className="nav" role="tablist">
                <li className="nav-item" role="presentation">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      window.history.back();
                    }}
                  >
                    <img src="/assets/images/back.png" width={30} alt="back" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="wraper">
        <div className="box_shadow mt-14">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-bold">Hotel Name / City</label>
              <input
                className="form-control"
                type="text"
                name="hotelName"
                value={filters.hotelName}
                onChange={handleChange}
                placeholder="Search by hotel or city"
              />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-bold">Reference No</label>
              <input
                className="form-control"
                type="text"
                name="bookingRefNo"
                value={filters.bookingRefNo}
                onChange={handleChange}
                placeholder="Ref No"
              />
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold">From Date</label>
              <input
                type="text"
                id="fromDate"
                className="form-control"
                placeholder="DD/MM/YYYY"
                value={filters.fromDate}
                style={{ cursor: "pointer" }}
                readOnly
              />
            </div>
            <div className="col-md-2">
              <label className="form-label fw-bold">To Date</label>
              <input
                type="text"
                id="toDate"
                className="form-control"
                placeholder="DD/MM/YYYY"
                value={filters.toDate}
                style={{ cursor: "pointer" }}
                readOnly
              />
            </div>
            
            <div className="col-md-3">
              <label className="form-label fw-bold">Booking Status</label>
              <select
                className="form-select"
                name="bookingStatus"
                value={filters.bookingStatus}
                onChange={handleChange}
              >
                <option value="">All Booking Statuses</option>
                <option value="PENDING">PENDING</option>
                <option value="CONFIRMED">CONFIRMED</option>
                <option value="HOLD">HOLD</option>
                <option value="FAILED">FAILED</option>
                <option value="CANCELLATION_PENDING">CANCELLATION_PENDING</option>
                <option value="CANCELLED">CANCELLED</option>
                <option value="APPROVE_PENDING">APPROVE_PENDING</option>
                <option value="APPROVE_REJECTED">APPROVE_REJECTED</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Payment Status</label>
              <select
                className="form-select"
                name="paymentStatus"
                value={filters.paymentStatus}
                onChange={handleChange}
              >
                <option value="">All Payment Statuses</option>
                <option value="Success">Success</option>
                <option value="Requested">Requested</option>
                <option value="Failure">Failure</option>
                <option value="Refunded">Refunded</option>
                <option value="UnPaid">UnPaid</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Hotel PNR</label>
              <input
                className="form-control"
                type="text"
                name="hotelPNR"
                value={filters.hotelPNR}
                onChange={handleChange}
                placeholder="Hotel PNR"
              />
            </div>
            <div className="col-md-3 d-flex align-items-end">
              <button
                type="button"
                className="btn btn-primary w-100"
                onClick={handleSearch}
                disabled={loading}
              >
                {loading ? "..." : "Search"}
              </button>
            </div>
          </div>
        </div>

        <div className="box_shadow mt-4">
          <div className="table-responsive">
            <table className="table align-middle gs-0 gy-4 table-hover">
              <thead>
                <tr className="fw-bold bg-light">
                  <th className="ps-4">Sr No</th>
                  <th>RefNo.</th>
                  <th>Booking Status</th>
                  <th>ConfirmationNo</th>
                  <th>Hotel PNR</th>
                  <th>Booking Date</th>
                  <th>Amount</th>
                  <th>Hotel Name</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {console.log(currentRecords)}
                {currentRecords.length > 0 ? (
                  currentRecords.map((item, index) => (
                    <tr key={index}>
                      <td className="ps-4">{indexOfFirstRecord + index + 1}</td>
                      <td>
                        <span className="text-gray-800 fw-bold">
                          {item.bookingRefId ||
                            item.BookingRefId ||
                            item.confirmationNo ||
                            item.ConfirmationNo ||
                            item.referenceNo ||
                            item.ReferenceNo}
                        </span>
                      </td>
                      <td>
                        {(() => {
                          const status = (item.bookingStatus || item.BookingStatus || "").toUpperCase();
                          let badgeClass = "bg-secondary";
                          if (status === "CONFIRMED") badgeClass = "bg-success";
                          else if (["PENDING", "HOLD", "CANCELLATION_PENDING", "APPROVE_PENDING"].includes(status)) badgeClass = "bg-warning";
                          else if (["FAILED", "CANCELLED", "APPROVE_REJECTED"].includes(status)) badgeClass = "bg-danger";
                          return (
                            <span className={`badge ${badgeClass} text-white fw-bold px-3 py-1.5`} style={{ textTransform: "uppercase" }}>
                              {status || "-"}
                            </span>
                          );
                        })()}
                      </td>
                      <td>
                        <span className="text-gray-600">
                          {item.confirmationNo ||
                            item.ConfirmationNo ||
                            item.pnr ||
                            item.PNR ||
                            "-"}
                        </span>
                      </td>
                      <td>
                        <span className="text-gray-600">
                          {item.hotelPNR ||
                            item.HotelPNR ||
                            "-"}
                        </span>
                      </td>
                      <td>
                        <span className="text-gray-600">
                          {item.createdAt ||
                          item.CreatedAt ||
                          item.bookingDate ||
                          item.BookingDate
                            ? new Date(
                                item.createdAt ||
                                  item.CreatedAt ||
                                  item.bookingDate ||
                                  item.BookingDate,
                              ).toLocaleString("en-GB", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })
                            : "-"}
                        </span>
                      </td>
                      <td>
                        <span className="fw-bold text-gray-900">
                          ₹{" "}
                          {(
                            item.totalPrice ||
                            item.TotalPrice ||
                            item.amount ||
                            item.Amount
                          )?.toLocaleString()}
                        </span>
                      </td>
                      <td>
                        <span className="text-gray-800">
                          {item.hotelName || item.HotelName} -{" "}
                          {item.cityName ||
                            item.CityName ||
                            item.sector ||
                            item.Sector}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex justify-content-center align-items-center" style={{ gap: "8px" }}>
                          <Link
                            to={`/reservations/hotel/TransactionsDetails?referenceno=${item.bookingRefId}`}
                            className="btn btn-sm btn-dark px-4 py-1"
                            style={{ background: "#110942" }}
                          >
                            View
                          </Link>
                          {/* {["CONFIRMED", "SUCCESS", "BOOKING CONFIRMED", "HOLD", "ON_HOLD", "PENDING"].includes((item.bookingStatus || item.BookingStatus || "").toUpperCase()) && (
                            <Link
                              to={`/reservations/hotel/CancellationBooking?ReferenceNo=${item.bookingRefId || item.BookingRefId || item.referenceNo || item.ReferenceNo}`}
                              className="btn btn-sm btn-danger px-3 py-1"
                            >
                              Cancel
                            </Link>
                          )} */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center py-5">
                      {loading ? (
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : !hasSearched ? (
                        <span className="text-muted">
                          Please enter search criteria and click Search to view transactions.
                        </span>
                      ) : (
                        <span className="text-muted">
                          No transactions found
                        </span>
                      )}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination Controls */}
          {transactions.length > 0 && (
            <div className="d-flex justify-content-between align-items-center flex-wrap mt-4 border-top pt-4">
              <div className="text-muted fs-7 mb-2">
                Showing <span className="fw-bold text-gray-800">{indexOfFirstRecord + 1}</span> to{" "}
                <span className="fw-bold text-gray-800">
                  {Math.min(indexOfLastRecord, transactions.length)}
                </span> of{" "}
                <span className="fw-bold text-gray-800">{transactions.length}</span> entries
              </div>
              <nav aria-label="Table pagination">
                <ul className="pagination pagination-circle pagination-outline justify-content-end mb-0" style={{ gap: "4px" }}>
                  <li className={`page-item previous ${currentPage === 1 ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                      disabled={currentPage === 1}
                      style={{ cursor: currentPage === 1 ? "not-allowed" : "pointer" }}
                    >
                      <i className="fa fa-chevron-left fs-8"></i>
                    </button>
                  </li>
                  {getPageNumbers().map((page, index) => {
                    if (page === "...") {
                      return (
                        <li key={`ellipsis-${index}`} className="page-item disabled">
                          <span className="page-link border-0">...</span>
                        </li>
                      );
                    }
                    return (
                      <li
                        key={page}
                        className={`page-item ${currentPage === page ? "active" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(page)}
                          style={{
                            backgroundColor: currentPage === page ? "#110942" : "transparent",
                            borderColor: currentPage === page ? "#110942" : "",
                            color: currentPage === page ? "#fff" : "",
                            fontWeight: currentPage === page ? "600" : "400"
                          }}
                        >
                          {page}
                        </button>
                      </li>
                    );
                  })}
                  <li className={`page-item next ${currentPage === totalPages ? "disabled" : ""}`}>
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                      disabled={currentPage === totalPages}
                      style={{ cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}
                    >
                      <i className="fa fa-chevron-right fs-8"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default AllTransactions;
